module.exports = __webpack_public_path__ + "static/img/head.ddd415db.png";